import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import ModalErrorAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalErrorAutoT/ModalErrorAutoT";
import AbonarMP from "../AbonarMP/AbonarMP";
import MercadoPagoQRDesktop from "../MercadoPagoQRDesktop/MercadoPagoQRDesktop";
import AtencioSinTurno from "../AtencionSinTurno/AtencionSinTurno";
import AtencionSinTurnoSelect from "../AtencionSinTurnoSelect/AtencionSinTurnoSelect";
import ConfirmarMedicoSolicitante from "../ConfirmarMedicoSolicitante/ConfirmarMedicoSolicitante";
import ConfirmOrden from "../ConfirmOrden/ConfirmOrden";
import DemoraPaciente from "../DemoraPaciente/DemoraPaciente";
import EfectivoMP from "../EfectivoMP/EfectivoMP";
import FilaVirtual from "../FilaVirtual/FilaVirtual";
import FilaVirtualCasa from "../FilaVirtualCasa/FilaVirtualCasa";
import FilaVirtualMasInfo from "../FilaVirtualMasInfo/FilaVirtualMasInfo";
import FilaVirtualMasInfoCasa from "../FilaVirtualMasInfoCasa/FilaVirtualMasInfoCasa";
import Home from "../Home/Home";
import HomeLabo from "../HomeLabo/HomeLabo";
import MedicoSolicitante from "../MedicoSolicitante/MedicoSolicitante";
import NecesitoTurno from "../NecesitoTurno/NecesitoTurno";
import OtrosTramites from "../OtrosTramites/OtrosTramites";
import PreguntarCentro from "../PreguntarCentro/PreguntarCentro";
import PuntoControl from "../PuntoControl/PuntoControl";
import RequiereAutorizacion from "../RequiereAutorizacion/RequiereAutorizacion";
import Resultados from "../Resultados/Resultados";
import Resumen from "../Resumen/Resumen";
import SelectFamiliar from "../SelectFamiliar/SelectFamiliar";
import SubirOrden from "../SubirOrden/SubirOrden";
import SeleccionOrden from "../SeleccionOrden/SeleccionOrden";
import FirmaOrdenDigital from "../FirmaOrdenDigital/FirmaOrdenDigital";
import TiempoExtra from "../TiempoExtra/TiempoExtra";
import TurnoProximo from "../TurnoProximo/TurnoProximo";
import TurnosDelDia from "../TurnosDelDia/TurnosDelDia";
import TurnosRecepcionadosQR from "../TurnosRecepcionadosQR/TurnosRecepcionadosQR";
import UbicacionActual from "../UbicacionActual/UbicacionActual";
import UbicacionSinTurno from "../UbicacionSinTurno/UbicacionSinTurno";
import ValidarCobertura from "../ValidarCobertura/ValidarCobertura";
import NumeroAfiliado from "../NumeroAfiliado/NumeroAfiliado";
import TurnosDelDiaLabo from "../TurnosDelDiaLabo/TurnosDelDiaLabo";
import ResumenLabo from "../ResumenLabo/ResumenLabo";
import ValidacionCoberturaLabo from "../ValidacionCoberturaLabo/ValidacionCoberturaLabo";
import TurnosRecepcionadosLabo from "../TurnosRecepcionadosLabo/TurnosRecepcionadosLabo";
import AbonarTurnoLabo from "../AbonarTurnoLabo/AbonarTurnoLabo";
import CierreRecepcionLabo from "../CierreRecepcionLabo/CierreRecepcionLabo";
import TiempoExtraLabo from "../TiempoExtraLabo/TiempoExtraLabo";
import TurnosConPresente from "../TurnosConPresenteLabo/TurnosConPresente";
import MasSolicitadosConsultas from "../MasSolicitados/MasSolicitadosConsultas";
import TipoTurnoConsulta from "../TipoTurno/TipoTurnoConsulta";
import TurnoRecepcionadoLabo from "../TurnoRecepcionadoLabo/TurnoRecepcionadoLabo";
import SelectorCircuito from "../SelectorCircuito/SelectorCircuito";
import OrdenesDigitales from "../OrdenesDigitales/OrdenesDigitales";
import AgendasDisponibles from "../AgendasDisponibles/AgendasDisponibles";
import OtroCentro from "../OtroCentro/OtroCentro";
import EstudiosLabo from "../EstudiosLabo/EstudiosLabo";
import CircuitoSinTurno from "../CircuitoSinTurno/CircuitoSinTurno";
import DemandaEspontanea from "../DemandaEspontanea/DemandaEspontanea";
import TurnosRecepcionados from "../TurnoRecepcionado/TurnoRecepcionado";

export const pasos = {
  Home,
  UbicacionActual,
  Resumen,
  TurnosDelDia,
  Loading,
  ModalErrorAutoT,
  MedicoSolicitante,
  PuntoControl,
  ConfirmarMedicoSolicitante,
  SubirOrden,
  SeleccionOrden,
  FirmaOrdenDigital,
  TurnoProximo,
  TurnosRecepcionadosQR,
  TurnosRecepcionados,
  AbonarMP,
  MercadoPagoQRDesktop,
  EfectivoMP,
  ValidarCobertura,
  NecesitoTurno,
  OtrosTramites,
  AtencioSinTurno,
  TiempoExtra,
  UbicacionSinTurno,
  PreguntarCentro,
  SelectFamiliar,
  AtencionSinTurnoSelect,
  HomeLabo,
  Resultados,
  ConfirmOrden,
  FilaVirtual,
  FilaVirtualMasInfo,
  FilaVirtualCasa,
  FilaVirtualMasInfoCasa,
  RequiereAutorizacion,
  DemoraPaciente,
  NumeroAfiliado,
  TurnosDelDiaLabo,
  ResumenLabo,
  ValidacionCoberturaLabo,
  TurnoRecepcionadoLabo,
  TurnosRecepcionadosLabo,
  AbonarTurnoLabo,
  CierreRecepcionLabo,
  TiempoExtraLabo,
  TurnosConPresente,
  MasSolicitadosConsultas,
  TipoTurnoConsulta,
  SelectorCircuito,
  OrdenesDigitales,
  AgendasDisponibles,
  OtroCentro,
  EstudiosLabo,
  CircuitoSinTurno,
  DemandaEspontanea
};
